export default __webpack_public_path__ + "static/media/A5_EN_COPY.48ece959.png";